import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css';
import { ROUTES } from 'constants/routes';
import { POPULAR_CITIES } from 'constants/popularCities';

// Compact row of links to the /events/:citySlug landing pages. Shown in both
// footer variants so every page interlinks the city pages (they'd otherwise
// only be reachable from the sitemap).
const CityLinks = () => (
  <nav className="footer-cities" aria-label="BJJ open mats by city">
    <span className="footer-cities-label">Open mats &amp; BJJ events:</span>
    {POPULAR_CITIES.map((c) => (
      <Link key={c.slug} to={ROUTES.cityEvents(c.slug)}>
        {c.name}
      </Link>
    ))}
  </nav>
);

const Footer = ({ variant = 'minimal' }) => {
  if (variant === 'minimal') {
    return (
      <footer className="footer footer-minimal">
        <div className="footer-minimal-inner">
          <CityLinks />
          <span className="footer-copy">© {new Date().getFullYear()} OpenMat</span>
          <div className="footer-minimal-links">
            <Link to={ROUTES.terms}>Terms</Link>
            <Link to={ROUTES.privacy}>Privacy</Link>
            <Link to={ROUTES.impressum}>Impressum</Link>
          </div>
        </div>
      </footer>
    );
  }
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-logo">
          <img src="/logo-horizontal.png" alt="OpenMat" className="footer-logo-img" />
        </span>
        <div className="footer-links">
          <Link to={ROUTES.openMatEvents}>Our Events</Link>
          <a href="/#faq">FAQ</a>
          <Link to={ROUTES.terms}>Terms of Service</Link>
          <Link to={ROUTES.privacy}>Privacy Policy</Link>
          <Link to={ROUTES.cookies}>Cookie Policy</Link>
          <Link to={ROUTES.impressum}>Impressum</Link>
          <a href="mailto:hello@the-open-mat.com">hello@the-open-mat.com</a>
          <a href="https://instagram.com/openmat_app" target="_blank" rel="noopener noreferrer">
            @openmat_app
          </a>
        </div>
        <span className="footer-copy">© {new Date().getFullYear()} OpenMat</span>
      </div>
      <div className="footer-inner footer-inner-cities">
        <CityLinks />
      </div>
    </footer>
  );
};

export default Footer;
